/**
 * Standard `border-width` values.
 *
 * @see https://www.figma.com/design/fXJgb6WJoQ6L1hpdCVpEh6/Colors?node-id=127-110&m=dev&vars=1
 */
export const enum LineWeight {
  Small = 1,
  Large = 2,
}
